"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("../../styles");
var useStyles = (0, styles_1.makeStyles)(function () { return ({
    inputRoot: {
        paddingRight: function (_a) {
            var showTextFieldEndAdornment = _a.showTextFieldEndAdornment;
            return (!showTextFieldEndAdornment ? '0 !important' : undefined);
        }
    },
    clearIndicator: {
        display: 'none'
    },
    clearIndicatorDirty: {
        display: 'inline-flex'
    }
}); });
exports.default = useStyles;
